var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-XLPageBanner"},[_c('div',{staticClass:"pg"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.entitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }